/**
 * 登录
 * created by leilei
 *
 */

import React from 'react';
import {Button, Form, Input, Modal, Spin, message, Icon} from 'antd';
import {LockOutlined, UserOutlined, SafetyOutlined} from '@ant-design/icons';
import CryptoJs from 'crypto-js'
import RequestComponent from "../../base/RequestComponent";
import {connect} from "react-redux";
import config from "../../config";
import {begin} from "../../base/auth";
import {applicationName, findUrlData, uuid} from "../../utils";
import {
    getInfoFromLocalStorage,
    loadNavigateData,
    setInfoToLocalStorage,
    loadSystemConfigList,
    loadCurrentUser,
    changeLoginStatus,
    updataNavigateData, removeInfoFromLocalStorage
} from "../../actions";
import ComPassword from '../../components/amendPassword/components/ComPassword';
import {accountValidate} from "../../utils/validate";
import ChangeDept from "./changeDept/ChangeDept";
import request from "../../base/request";
import loginBackground from './img/loginBackground.png';
import loginLogo from './img/loginLogo.png';
import {getModAuth} from './../../base/BaseComponent'
import {LOAD_SYSTEM_CONFIG} from "../../constants";
import sub_account from "./img/sub_account.png";
import lock from "./img/lock.png";
import loginOneImg from './img/loginImg.gif';
import check from "./img/check.png";
import left_background from "./img/left_background.png";
import ChangePassword from "./changePassword/ChangePassword";

let MD5 = (str)=>CryptoJs.MD5(str).toString();
class Login extends RequestComponent {

    timer;
    writePhoneCodeTimeDefault = 60 * 3;
    state = {
        phoneCodeRefVal:"",
        phoneNumberRefVal:"",
        writePhoneCodeTime: this.writePhoneCodeTimeDefault,//验证码过期的时间
        showPhoneCode:false,
        sysLoginBackgroundColor:"",
        loginSuccessShowInfo:true,
        loginImg: "",
        loginTitle: "",
        sysLoginLogoMarginTop: "",
        sysLoginTitleMarginTop: "",
        sysLoginLeftWholeImg: "",
        newSecondSelectColor:"",
        sysLoginLogoWidth: "",
        sysLoginLogoHeigh: "",
        isStartLogin: false,//是否是开始登录了
        currentAccountPhone: "",
        images: [],//背景轮播图
        copyRight:"",
        copyRightEn:"",
        codeImage:"",
        pwdLevel:"",
        publicKey:'',
        visible: false,
        deptList:[],
    };

    constructor(props){
        super(props);
        if(this.props.msg && !this.props.msg.startsWith("version") && !this.props.msg.startsWith("time")&& !this.props.msg.startsWith("accessToken")){
            message.error(this.props.msg)
        }
        this.props.updataNavigateData([]);
        //删除历史基本信息及token
        this.removeInfo();
    }
    componentWillMount() {
        let accessToken = window.UrlParam.paramValues('accessToken');
        let expireTime = window.UrlParam.paramValues('expireTime');
        let refreshToken = window.UrlParam.paramValues('refreshToken');
        let jump = window.UrlParam.paramValues('jump');
        if(typeof  accessToken =='object'){
            accessToken=accessToken[0]
        }
        if(typeof  expireTime =='object'){
            expireTime=expireTime[0]
        }
        if(typeof  refreshToken =='object'){
            refreshToken=refreshToken[0]
        }
        if(typeof  jump =='object'){
            jump=jump[0]
        }
        if(jump){
            jump=decodeURIComponent(jump);
            window.location.href =jump
        }else if (accessToken && expireTime && refreshToken) {
            this.systemInit({accessToken, expireTime, refreshToken}, () => {
                let currentHash = window.location.hash.replace('#', '');
                let navigateData = getInfoFromLocalStorage('menu') || [];//window.cmsitesNavigateData;
                if (navigateData && navigateData.length) {
                    if (!currentHash) {
                        window.location.href = window.location.origin + window.location.pathname + '#' + navigateData[0].path;
                    } else {
                        window.location.href = window.location.origin + window.location.pathname + '#' + currentHash;
                    }
                }
            });
            console.log('走了单点登录')
        }else{
            this.getConfigValuesByKeys();
            this.changeCodeImg();
        }
    }

    componentDidMount() {
       /* this.request({
            url:"/cm-sites-sys/config/getLoginConfig",
            callBack:(data)=>{
                let images = data[applicationName()+".login.backgroundImgs"];
                let loginTitle = data[applicationName()+".project.login.title"];
                let loginImg = data["loginImg"] || this.state.loginImg;
                let copyright = data["copyright"];
                let copyRightEn = data["copyright_en"];
                let newSecondSelectColor = data["newSecondSelectColor"] || this.state.newSecondSelectColor;
                let loginSuccessShowInfo = data["login.success.show.info"] !== "false";
                this.setState({images,loginTitle,loginImg,copyright,copyRightEn,newSecondSelectColor, loginSuccessShowInfo})
            },
            haveToken: false
        });*/
        this.userNameRef.focus()
        // window.onkeydown = e=>{
        //     if(e.keyCode ===13){
        //         this.onSubmit();
        //     }
        // }
    }
    // 登录页面的配置项
    getConfigValuesByKeys = () => {
        let url = "/cm-sites-sys/config/getConfigValuesByKeys";
        let sysConfig = [
            "login_backgroundImg",
            "sys_login_logo",
            "system_loginTitle",
            "sys_login_copyright",
            "sys_login_copyRightEn",
            "sys_login_backgroundColor",
            "sysLoginLogoWidth",
            "sysLoginLogoHeight",
            "sysLoginLogoMarginTop",
            "sysLoginLeftWholeImg",
            "sysLoginTitleMarginTop",
            "newSecondSelectColor",
        ];
        let loginImg = loginLogo;
        let loginTitle = "融媒体管理平台";
        let images = [loginBackground];
        let copyRight = "西安博达软件股份有限公司版权所有";
        let copyRightEn = "© COPYRIGHT WEBBERSOFT ALL RIGHTS RESERVERD";
        let sysLoginBackgroundColor = "#0050B3";
        let that = this;
        let sysLoginLogoMarginTop = '93';
        let sysLoginTitleMarginTop = '20';
        let newSecondSelectColor = '#0050B3';
        let sysLoginLogoWidth = '213';
        let sysLoginLogoHeight = '48';
        //系统logo、登录背景图、登录系统文字、版权、登录背景色配置项接口
        request({
            url, method: 'post', body: sysConfig, contentType: 'json', haveToken: false, callBack: (data) => {
                // 登录背景图
                if (data && data.login_backgroundImg && data.login_backgroundImg.length) {
                    this.state.images = data.login_backgroundImg;
                } else {
                    this.state.images = images;
                }
                // 登录logo
                if (data && data.sys_login_logo && data.sys_login_logo.length) {
                    this.state.loginImg = data.sys_login_logo;
                }
                // 登录名称
                if (data && data.system_loginTitle && data.system_loginTitle.length) {
                    this.state.loginTitle = data.system_loginTitle;
                }
                // 版权
                if (data && data.sys_login_copyright && data.sys_login_copyright.length) {
                    this.state.copyRight = data.sys_login_copyright;
                }
                // 英文版权
                if (data && data.sys_login_copyRightEn && data.sys_login_copyRightEn.length) {
                    this.state.copyRightEn = data.sys_login_copyRightEn;
                }
                // 登录框背景色
                if (data && data.sys_login_backgroundColor && data.sys_login_backgroundColor.length) {
                    this.state.sysLoginBackgroundColor = data.sys_login_backgroundColor;
                } else {
                    this.state.sysLoginBackgroundColor = sysLoginBackgroundColor;
                }
                // 登录框背景色
                if (data && data.newSecondSelectColor && data.newSecondSelectColor.length) {
                    this.state.newSecondSelectColor = data.newSecondSelectColor;
                } else {
                    this.state.newSecondSelectColor = newSecondSelectColor;
                }
                // 登录logo距离顶部高度
                if (data && data.sysLoginLogoMarginTop && data.sysLoginLogoMarginTop.length) {
                    this.state.sysLoginLogoMarginTop = data.sysLoginLogoMarginTop;
                } else {
                    this.state.sysLoginLogoMarginTop = sysLoginLogoMarginTop;
                }
                // 登录左侧背景图片
                if (data && data.sysLoginLeftWholeImg && data.sysLoginLeftWholeImg.length) {
                    this.state.sysLoginLeftWholeImg = data.sysLoginLeftWholeImg;
                } else {
                    this.state.sysLoginLeftWholeImg = left_background;
                }
                // 登录标题距离顶部高度
                if (data && data.sysLoginTitleMarginTop && data.sysLoginTitleMarginTop.length) {
                    this.state.sysLoginTitleMarginTop = data.sysLoginTitleMarginTop;
                } else {
                    this.state.sysLoginTitleMarginTop = sysLoginTitleMarginTop;
                }
                // 登录logo宽度
                if (data && data.sysLoginLogoWidth && data.sysLoginLogoWidth.length) {
                    this.state.sysLoginLogoWidth = data.sysLoginLogoWidth;
                } else {
                    this.state.sysLoginLogoWidth = sysLoginLogoWidth;
                }
                // 登录logo高度
                if (data && data.sysLoginLogoHeight && data.sysLoginLogoHeight.length) {
                    this.state.sysLoginLogoHeight = data.sysLoginLogoHeight;
                } else {
                    this.state.sysLoginLogoHeight = sysLoginLogoHeight;
                }
                that.setState({})
            }
        });
    };

    componentWillUnmount(){
        window.onkeydown=null
    }

    pwdStrengthVerify(pwd){
        //密码强度验证
        let body={
            status:false,
            isFirst:true
        };
        let ls = 0;
        if(pwd.match(".*[0-9]+.*")){
            ls++;
        }
        if(pwd.match(".*[a-z]+.*")){
            ls++;
        }
        if(pwd.match(".*[A-Z]+.*")){
            ls++;
        }
        if(pwd.match(".*[~!@#$%^&*()_+|<>,.?/:;'\\[\\]{}\"]+.*")){
            ls++;
        }
        if(this.state.pwdLevel === '1'){
            if(ls < 2){
                body.status=true;
            }
        }else if (this.state.pwdLevel === '2'){
            if(ls < 3){
                body.status=true;
            }
        }
        setInfoToLocalStorage("loginPassword",body);
    }

    uuid = "";
    changeCodeImg = ()=>{
        this.request({
            url:"/cm-sites-sys/login/code",
            body:{uuid:this.uuid},
            callBack:(data)=>{
                if(!this.uuid){
                    this.uuid = data.uuid;
                }
                this.setState({codeImage : data.image})
            },
            haveToken:false
        });
    };

    onSubmit = e => {
        e && (typeof e.preventDefault == 'function') && e.preventDefault();
        let that = this;
        this.props.form.validateFields((err, values) => {
            // 用户名去除前后空格 输入用户名前后包含空格也可以提交
            if(values.username){
                values.username=values.username.trim()
            }
            if(!accountValidate(values.username)){
                return;
            }

            if(!values.password){
                message.destroy();
                message.error("请输入密码！");
                return;
            }
            if(!values.loginCode){
                message.destroy();
                message.error("请输入验证码！");
                return;
            }
            if(values.password.length> 20){
                message.destroy();
                message.error("密码最多可输入20字！");
                return false
            }
            this.pwdStrengthVerify(values.password);
            let passAndPublicKey= window.encryption(values.password);
            let params1 = {
                uuid:this.uuid,
                code : values.loginCode,
                //account : values.username,
                //password : process.env.REACT_APP_NAME=='sys'? MD5(MD5(values.password).toLowerCase() + values.loginCode):passAndPublicKey.pass,
                //password : passAndPublicKey.pass,
                //loginType:"baseLogin",
            };
            let params = {
                uuid:this.uuid,
                code : values.loginCode,
                account : values.username,
                //password : process.env.REACT_APP_NAME=='sys'? MD5(MD5(values.password).toLowerCase() + values.loginCode):passAndPublicKey.pass,
                password : passAndPublicKey.pass,
                loginType:"baseLogin",
            };
           // if(process.env.REACT_APP_NAME!=='sys'){
                params.publicKey=passAndPublicKey.publicKey
           // }
           window.loading.show();
            that.request({url:"/cm-sites-sys/login/checkCode",body:params1, callBack:data=>{
                    window.loading.hide();
                    // console.log(data)
                    that.request({
                        url: "/cm-sites-sys/v2/login",
                        body:params,
                        method:"post",
                        contentType:'form-data',
                        callBack:(dto,status,allData)=>{
                            console.log("dto:    ", dto,status,allData);
                            if(!dto.code&&status===200){
                                console.log("登录成功，系统正在初始化，请稍后...");
                                that.setState({isStartLogin:true});
                                that.systemInit(dto.data);
                            }else if(status===5005){ //状态是5005 切换部门
                                if(allData&&allData.data&&allData.data.deptAndRoles){
                                    let deptList=allData.data.deptAndRoles;
                                    let key=allData.data.key;
                                    this.ChangeDept.showModal(deptList,key,(deptData)=>{
                                        console.log("deptData========",deptData);
                                        that.systemInit(deptData)
                                    });
                                }else{
                                    that.changeCodeImg()
                                }
                            }else if (status === 4022 || status === 4023) { //状态是4022 首次登录修改密码
                                if (allData?.data?.key && allData?.data?.userId) {
                                    let userId = allData.data.userId;
                                    let key = allData.data.key;
                                    let token = allData.data.tempToken;
                                    setInfoToLocalStorage("Token", token);
                                    that.ChangePassword.showModal(userId, key, allData);
                                } else {
                                    that.changeCodeImg()
                                }
                            } else{
                                if(["sys.009", "sys.010"].indexOf(dto.code) !== -1){
                                    that.setState({
                                        showPhoneCode: true,
                                        currentAccountPhone:"sys.009" === dto.code? dto.phone : "",
                                        phoneNumberRefVal:"sys.009" === dto.code? dto.phone : "",
                                    });
                                }else{
                                    that.changeCodeImg();
                                }
                            }
                        }, errorCallBack:()=>{
                            window.loading.hide();
                            that.changeCodeImg();
                        }, serverVerify:{
                            serverErrorCallBack:(e,allData)=>{
                                //解决部门切换功能的开发
                               /* window.loading.hide();
                                console.log('----',allData.data);
                                if(allData&&allData.data&&allData.data.deptAndRoles){
                                    let deptList=allData.data.deptAndRoles;
                                    let key=allData.data.key;
                                    this.ChangeDept.showModal(deptList,key,(deptData)=>{
                                        that.systemInit(deptData)
                                    });

                                }else{
                                    that.changeCodeImg()
                                }*/
                                window.loading.hide();
                                that.changeCodeImg();
                            },
                            isShowErrorMsg:true,
                        },
                        haveToken: false
                    })
                }, errorCallBack:()=>{
                    window.loading.hide();
                    that.changeCodeImg();
                }, serverVerify:{
                    serverErrorCallBack:(e)=>{
                        // console.log("==============",e)
                        window.loading.hide();
                        that.changeCodeImg();
                    }
                },
                haveToken: false
            })
        });
    };

    systemInit = ({accessToken,expireTime, refreshToken},call=()=>{
        let currentHash = window.location.hash.replace('#', '');
        let navigateData = getInfoFromLocalStorage('menu') || [];//window.cmsitesNavigateData;
        if (navigateData && navigateData.length) {
            // 如果路由存在一级菜单中则不做处理
            let isMyRoute = currentHash && findUrlData(currentHash, navigateData);
            if (!currentHash || !isMyRoute?.stopFind) {
                window.location.href = window.location.origin + window.location.pathname + '#' + navigateData[0].path;
            } else {
                window.location.href = window.location.origin + window.location.pathname + '#' + currentHash;
            }
        }
    })=>{//正常登录之后系统初始化操作，如果登录了之后刷新页面，该方法是不会执行的,登录之后刷新会执行/route/index.js中的初始化方法
        setInfoToLocalStorage("Token", accessToken);
        setInfoToLocalStorage("expireTime", expireTime);
        setInfoToLocalStorage("refreshToken", refreshToken);
        let isError = false;
        let changeLoginStatus = (status)=>{
            if(!isError){
                isError = status === "false"?true:false;
                this.props.changeLoginStatus({status});
            }
            if(isError){
                removeInfoFromLocalStorage("Token");
                this.setState({
                    isStartLogin: false
                });
                this.changeCodeImg();
            }
        };

        let stepCount =3;
        let loadNext =()=>{
            stepCount -- ;
            if(stepCount === 0){
                this.loadEnd();
                let {currentUser:{id}} = this.getInfo();
                window.getInfo = this.getInfo;
                begin(id,()=>{
                    this.props.changeLoginStatus({status:"false"});
                });
                call&&call();
                changeLoginStatus("true");
            }
        };

        this.loadStart();
        this.props.loadCurrentUser((data)=>{
            let currentUser={...data}
            if(data.defaultInfo&&data.defaultInfo.dept){
                currentUser.deptIds=[data.defaultInfo.dept.id];
                currentUser.deptList=[data.defaultInfo.dept];
                let roleList=data.defaultInfo.roleList||[];
                let roleCodes=[];
                roleList.forEach(role=>{
                    roleCodes.push(role.roleCode)
                });
                currentUser.roleCodes=roleCodes;
                currentUser.roleList=roleList;
            }
            setInfoToLocalStorage("currentUser", currentUser);
            setInfoToLocalStorage("permissionsUserAccount", data.account);
            //设置权限
            let permissions=[];
            if(data.defaultInfo&&data.defaultInfo.permissionList&&data.defaultInfo.permissionList.length){
                data.defaultInfo.permissionList.forEach(item=>{
                    permissions.push(item.code)
                })
            }
            setInfoToLocalStorage("permissions", permissions);
            console.log("用户加载完成！");
            getModAuth(()=>{
                loadNext();
            });
        }, ()=>{
            console.log("用户加载失败！");
            changeLoginStatus("false");
        });
        //加载系统配置项
         this.props.loadSystemConfigList((data)=>{
             // console.log(data);
            setInfoToLocalStorage("config", data);
            loadNext();
            console.log("系统配置加载完成！")
         }, ()=>{
             message.error("系统配置加载失败！");
             changeLoginStatus("false");
         });
        //获取用户菜单
        let url = `/cm-sites-sys/menu/findUserMenuTree?clientType=0`;
        let body ={reload: true};
        this.request({url, body, callBack:(Data)=>{
            if(Data){
                let data=Data.child;
                if(!data || (data.length === 0)){
                    message.error("菜单为空，没有可管理的内容，无法登录！");
                    changeLoginStatus("false");
                }else{
                    setInfoToLocalStorage("menu", data);
                    this.props.loadNavigateData();
                    loadNext();
                }
            }
        },errorCallBack:()=>{
            message.error("用户菜单获取失败！");
            changeLoginStatus("false");
        }});
    };

    createPhoneCode=()=>{
        if(!this.state.currentAccountPhone && !this.state.phoneNumberRefVal){
            message.error("请填写手机号！");
            return;
        }
        if(!this.state.currentAccountPhone && !/^1\d{10}/.test(this.state.phoneNumberRefVal)){
            message.error("手机号格式不合法！");
            return;
        }
        window.loading.show();
        this.request({
            url:"/cm-sites-sys/login/getPhoneVerifyCode",
            method:"post",
            callBack:()=>{
                this.state.writePhoneCodeTime = this.writePhoneCodeTimeDefault;
                this.timer = window.setInterval(()=>{
                    this.state.writePhoneCodeTime--;
                    if(this.state.writePhoneCodeTime<=0){
                        window.clearInterval(this.timer);
                        this.timer = null;
                    }
                    this.setState({})
                }, 1000);
                this.setState({});
                window.loading.hide();
            }
        });
    };

    phoneCodeVerify=()=>{
        this.props.form.validateFields((err, values) => {
            //绑定手机号
            let params = {
                logincode : values.loginCode,
                password : MD5(MD5(values.password).toLowerCase() + values.loginCode)
            };
            this.request({
                url: "/cm-sites-sys/login/phoneVerify",
                body:{
                    ...params, code:this.state.phoneCodeRefVal
                },
                callBack:()=>{
                    window.location.href=`/cm-sites/${applicationName()}/framereact/index.html?time=${new Date().getTime()}#/`;
                }
            });
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        let contentAreaHeight = 400;
        let color = "#f4f4f4";
        let opacity = 0.8;
        let {isStartLogin} = this.state;
        if(isStartLogin){
            let loadingDom = <table width={"100%"} height={"100%"}>
                <tbody>
                <tr width={"100%"} height={"100%"}>
                    <td width={"100%"} height={"100%"} align={"center"} valign={"middle"}><Spin /></td>
                </tr>
                </tbody>
            </table>;
            return loadingDom;
        }
        let accessToken = window.UrlParam.paramValues('accessToken');
        if(typeof  accessToken =='object'){
            accessToken=accessToken[0]
        }
        let height = document.body.clientHeight
        return (
            <div>
                <div style={{display:accessToken?'':'none',}}><img src={loginOneImg} style={{width:'100%',height:height,objectFit:'cover'}} alt=""/></div>
                <ImageLoop key={uuid()} images={this.state.images}/>
                <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{height:"100vh",position: 'relative',display:accessToken?'none':''}}><tbody>
                    <tr><td valign={"middle"} align={"center"} style={{height:"100vh"}}>
                        <div style={{height:contentAreaHeight+"px",width:"650px",textAlign:"left"}}>
                            <table cellSpacing={0} cellPadding={0} border={0} width={650} height={contentAreaHeight}>
                                <tbody>
                                <tr>
                                    <td width={280} align={"center"} valign={"middle"}>
                                        <div style={{
                                            width: "100%",
                                            opacity,
                                            height: "300px",
                                            backgroundColor: this.state.sysLoginBackgroundColor,
                                            backgroundImage: `url(${this.state.sysLoginLeftWholeImg})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPositionX: 'right',
                                            borderRadius: "5px 0 0 5px"
                                        }}>
                                            <div style={{
                                                display:'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}>
                                                {this.state.loginImg ?
                                                    <div style={{
                                                        display: 'inline-block',
                                                        marginTop: this.state.sysLoginLogoMarginTop + "px",
                                                        // marginBottom: 30,
                                                    }}>
                                                        <img src={this.state.loginImg} style={{
                                                            objectFit: 'cover',
                                                            width: this.state.sysLoginLogoWidth + "px",
                                                            height: this.state.sysLoginLogoHeight + "px",
                                                        }}/>
                                                    </div> : null }
                                                {this.state.loginTitle ?
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: this.state.sysLoginTitleMarginTop + "px",
                                                        fontSize: 24,
                                                        fontWeight: 700,
                                                        color
                                                    }}>{this.state.loginTitle}</div> : null}
                                            </div>
                                        </div>
                                    </td>
                                    <td valign={"center"}>
                                        <div style={{
                                            width: "100%",
                                            height: "300px",
                                            opacity: 0.9,
                                            background: "#fff",
                                            padding: "33px 50px",
                                            borderRadius: "0 5px 5px 0"
                                        }}>
                                            <Form
                                                name="normal_login"
                                                className="login-form"
                                                onSubmit={this.onSubmit}
                                            >
                                                <Form.Item
                                                    style={{paddingBottom: '8px'}}
                                                >
                                                    {getFieldDecorator("username", {
                                                    })(<Input maxLength={50} ref={userNameRef=>this.userNameRef=userNameRef} size="large"
                                                              // prefix={<UserOutlined className="site-form-item-icon"/>}
                                                              prefix={<img src={sub_account}/>}
                                                              allowClear={true}
                                                              placeholder="请输入账号"
                                                              // onKeyDown={e=>{
                                                              //   e.stopPropagation()
                                                              //   if(e.keyCode === 13 ){
                                                              //       this.passwordRef.focus()
                                                              //   }
                                                              // }}
                                                              />)}
                                                </Form.Item>
                                                <Form.Item
                                                    style={{paddingBottom: '8px'}}
                                                >
                                                    {getFieldDecorator("password",{
                                                    })(<ComPassword
                                                        size="large"
                                                        prefix={<img src={lock}/>}
                                                        type="password"
                                                        InputRef={ref=>this.passwordRef = ref}
                                                        // onKeyDown={e=>{
                                                        //     e.stopPropagation()
                                                        //     if(e.keyCode === 13 ){
                                                        //         console.log(this.codeRef);
                                                        //         console.log(this.passwordRef);
                                                        //         this.codeRef.focus()
                                                        //     }
                                                        // }}
                                                        placeholder="请输入密码"
                                                        allowClear={true}
                                                    />)}
                                                </Form.Item>
                                                <Form.Item
                                                    style={{paddingBottom: '8px'}}
                                                >
                                                    {getFieldDecorator("loginCode",{
                                                    })(<Input size="large"
                                                        // prefix={<SafetyOutlined className="site-form-item-icon"/>}
                                                              prefix={<img src={check}
                                                                           style={{width: 20, height: 20}}/>}
                                                              placeholder="请输入验证码"
                                                              allowClear={true}
                                                              maxLength={4}
                                                              ref={ref=>this.codeRef = ref}
                                                              suffix={<img src={this.state.codeImage} id="codeimg"
                                                                           style={{width: '63px', height: '30px',marginRight:'-5px'}}
                                                                           onClick={()=>this.changeCodeImg()} title="看不清点我" alt="看不清点我"/>}
                                                    />)}
                                                </Form.Item>

                                                <Form.Item>
                                                    <Button size={"large"}
                                                            type="primary" block={true} htmlType="submit" className="login-form-button">
                                                        登录
                                                    </Button>
                                                    <style>{
                                                        `
                                                        .login-form-button{background-color:${this.state.newSecondSelectColor};border-color:${this.state.newSecondSelectColor};font-weight: 700}
                                                        `
                                                    }
                                                    </style>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                    </td>
                                    <style>
                                        {
                                            `
                                        .login-form .ant-form-item {
                                            margin-bottom: 0px;
                                        }
                                        // input:-internal-autofill-selected {
                                        //     appearance: menulist-button;
                                        //     background-image: none !important;
                                        //     background-color: -internal-light-dark(rgb(255,255,255), rgba(70, 90, 126, 0.4)) !important;
                                        //     color: -internal-light-dark(black, white) !important;
                                        // }
                                        .login-form .ant-input{
                                            border-color:#C9E1FF;
                                        }
                                        .login-form .ant-input-affix-wrapper .ant-input:not(:first-child){
                                            padding-left:40px;
                                        }
                                        .ant-input:focus, .ant-input:hover, .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) { border-color: ${this.state.newSecondSelectColor} !important }
                                        `
                                        }
                                    </style>
                                </tr>
                                {(!this.state.copyRight && !this.state.copyRightEn) ?
                                    <tr>
                                        <td colSpan={2} align={"center"} height={100} style={{fontSize:12,color:'#fff'}}>
                                            <div style={{padding:" 10px 0"}} />
                                        </td>
                                    </tr>
                                    :
                                <tr>
                                    <td colSpan={2} align={"center"} height={100} style={{fontSize:12,color:'#fff'}}>
                                        <div
                                            style={{
                                                // padding:" 10px 0",
                                                // borderRadius: "10px",
                                                // background: "rgba(0, 80, 179,.3)",
                                            }}
                                        >
                                            <span style={{lineHeight:"25px"}}>{this.state.copyRight}</span><br />
                                            <span style={{lineHeight:"25px"}}>{this.state.copyRightEn}</span><br />
                                            <span style={{lineHeight:"25px"}}>外经贸网备 31424001</span>
                                        </div>
                                    </td>
                                </tr>}
                                </tbody>
                            </table>
                        </div>
                    </td></tr></tbody>
                </table>
                <Modal
                    visible={this.state.showPhoneCode}
                    title={"二次验证"}
                    footer={null}
                    onCancel={()=>this.setState({showPhoneCode:false})}
                >
                    {this.state.currentAccountPhone ? <Input type={"text"}
                                                             placeholder={"请填写手机号"}
                                                             value={this.state.currentAccountPhone}
                                                             key={"inputOne"}
                                                             disabled={true}
                                                             suffix={this.timer?<span>{this.state.writePhoneCodeTime}秒</span>:<span
                        onClick={()=>this.createPhoneCode()}
                        style={{cursor:"pointer"}}>获取验证码</span>}/>:<Input type={"text"} ref={(that)=>this.phoneNumberRef = that} key={"inputTwo"}
                                                                          onChange={e=>this.setState({phoneNumberRefVal:e.target.value})}
                                                                          placeholder={"请填写手机号"} suffix={this.timer?<span>{this.state.writePhoneCodeTime}秒</span>:<span
                        onClick={()=>this.createPhoneCode()}
                        style={{cursor:"pointer"}}>获取验证码</span>}/>}
                    <br /><br />
                    <Input type={"text"} ref={(that)=>this.phoneCodeRef = that}
                           onChange={e=>this.setState({phoneCodeRefVal:e.target.value})}
                           placeholder={"请填写验证码"} suffix={<span
                                onClick={()=>this.phoneCodeVerify()}
                                style={{cursor:"pointer"}}>确定</span>}/><br />
                </Modal>
                <ChangeDept ref={(e)=>{this.ChangeDept=e}}  refreshCode={()=>{
                    this.changeCodeImg()
                }} />
                <ChangePassword ref={node => this.ChangePassword = node} refreshCode={() => {
                    this.changeCodeImg()
                }}/>
            </div>
        )
    }
}

class ImageLoop extends RequestComponent{

    constructor(props){
        super(props);
    }

    timer;

    componentDidMount(){
        this.timer = window.setInterval(()=>{
            this.setState(prevState=>{
                let srcIndex = ++prevState.srcIndex;
                srcIndex = (srcIndex > this.props.images.length - 1) ? 0 : srcIndex;
                return {
                    ...prevState,
                    srcIndex
                }
            })
        }, 5000);
    }

    state = {
        srcIndex:0,
    };

    componentWillUnmount(){
        window.clearInterval(this.timer);
        this.timer = null;
    }

    render() {
        let accessToken = window.UrlParam.paramValues('accessToken');
        if(typeof  accessToken =='object'){
            accessToken=accessToken[0]
        }

        let imageSrc = this.props.images[this.state.srcIndex];
        return imageSrc ? <div className="aaaa" style={{
            width: "100%",
            height: "calc(100%)",
            overflow: "hidden",
            position: "absolute",
            backgroundImage: `url(${imageSrc})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            display:accessToken?'none':''
        }}/> : <div/>;
    }
}

function mapStateToMethod(dispatch) {
    return {
        loadSystemConfigList: function (callBack, errorCallBack) {
            return dispatch(loadSystemConfigList(callBack, errorCallBack));
        },
        loadCurrentUser: function (callBack, errorCallBack) {
            return dispatch(loadCurrentUser(callBack, errorCallBack));
        },
        changeLoginStatus: function (systemStatus) {
            return dispatch(changeLoginStatus(systemStatus))
        },
        loadNavigateData: function () {
            return dispatch(loadNavigateData())
        },
        updataNavigateData: function (data) {
            return dispatch(updataNavigateData(data))
        },
    }
}

export default Form.create({})(connect(null, mapStateToMethod,null,{forwardRef: true})(Login));